import _slicedToArray from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/submit.png';
import _imports_1 from '@/assets/more.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-374c6896"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_2 = {
  "class": "container"
};
var _hoisted_3 = {
  "class": "banner"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "title"
};
var _hoisted_6 = {
  "class": "name"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});
var _hoisted_8 = {
  "class": "list"
};
import Activity from '@/common/components/Activity.vue';
import ScreenScrollView from '@/common/components/ScreenScroll/ScreenScrollView.vue';
import { useNavigation } from '@/common/util/navigation';
import { useApiToState } from '@/common/util/useApiToState';
import IndexCardItem from '@/components/IndexCardItem.vue';
import { getApiFeedbackBanner, postApiFeedbackProblemList } from '@/service/api';
import defaultBanner from '@/assets/banner.png';
import { computed } from 'vue';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toNext = _useNavigation.toNext;
    var _useApiToState = useApiToState(function () {
        return getApiFeedbackBanner({
          appId: window.appId
        });
      }, defaultBanner),
      _useApiToState2 = _slicedToArray(_useApiToState, 1),
      banner = _useApiToState2[0];
    var autoNetworkBanner = computed(function () {
      var _banner$value;
      var bannerUrl = (_banner$value = banner.value) === null || _banner$value === void 0 ? void 0 : _banner$value.bannerUrl;
      if (!bannerUrl) return banner.value;
      if (String(bannerUrl).startsWith('http://')) return bannerUrl.replace('http://', '//');
      if (String(bannerUrl).startsWith('https://')) return bannerUrl.replace('https://', '//');
      return bannerUrl;
    });
    var _useApiToState3 = useApiToState(function () {
        return postApiFeedbackProblemList({
          appId: window.appId,
          pageSize: 6,
          pageIndex: 1
        });
      }),
      _useApiToState4 = _slicedToArray(_useApiToState3, 1),
      list = _useApiToState4[0];
    var toSubmit = function toSubmit() {
      toNext('/submit');
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "IndexView",
        fixed: false
      }, {
        overlay: _withCtx(function () {
          return [_createElementVNode("div", {
            "class": "button",
            onClick: toSubmit
          }, [_hoisted_1, _createTextVNode(_toDisplayString(_unref(t)('SubmitFeedback')), 1)])];
        }),
        "default": _withCtx(function () {
          return [_createVNode(ScreenScrollView, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
                src: _unref(autoNetworkBanner)
              }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('FrequentlyAskedQuestions')), 1), _createElementVNode("div", {
                "class": "more",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _unref(toNext)('/qa');
                })
              }, [_createTextVNode(_toDisplayString(_unref(t)('all')), 1), _hoisted_7])]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list) || [], function (item) {
                return _openBlock(), _createBlock(IndexCardItem, {
                  key: item.id,
                  item: item
                }, null, 8, ["item"]);
              }), 128))])])];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
});